import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { getTenantSlug } from '../../config/api';
import { ReactComponent as AppIconDark } from '../../assets/brand/app_icon_dark.svg';
import { ReactComponent as AppIconLight } from '../../assets/brand/app_icon_light.svg';

/**
 * Full-screen splash shown on first-ever visit to a tenant subdomain — the
 * one moment we don't have the tenant logo cached locally yet. We render
 * Vidya's mark with "Loading {slug}…" because we honestly don't know the
 * institute's logo URL until bootstrap returns. localStorage means this
 * only fires on the truly-first visit; every return visit paints the
 * cached tenant mark instantly with no splash at all.
 */
export const TenantSplash: React.FC = () => {
  const { isDarkMode } = useTheme();
  const slug = getTenantSlug();
  const slugDisplay = slug ? slug.toUpperCase() : '';
  const Icon = isDarkMode ? AppIconDark : AppIconLight;

  return (
    <div
      className={`fixed inset-0 z-50 flex flex-col items-center justify-center ${
        isDarkMode ? 'bg-[#030712]' : 'bg-gray-50'
      }`}
      role="status"
      aria-label={slug ? `Loading ${slugDisplay} portal` : 'Loading'}
    >
      <div className="flex flex-col items-center animate-pulse">
        <Icon width={44} height={44} style={{ borderRadius: 10 }} />
        <p
          className={`mt-3 text-sm font-medium tracking-wide ${
            isDarkMode ? 'text-slate-300' : 'text-gray-600'
          }`}
        >
          {slug ? `Loading ${slugDisplay}…` : 'Loading…'}
        </p>
      </div>
      <p
        className={`mt-4 text-xs tracking-wide ${
          isDarkMode ? 'text-slate-500' : 'text-gray-400'
        }`}
      >
        powered by <span className="font-medium">Vidya.ai</span>
      </p>
    </div>
  );
};

export default TenantSplash;
